import { ModuleKeys } from '@/types';

/**
 * Tenant-admin nav/route paths that require a specific module to be enabled.
 *
 * Only list paths whose backend routes are module-gated (and therefore 403 via
 * ModuleEnforcementMiddleware when the module is off). Cross-cutting pages
 * (orders, customers, providers, branding, finance, maps, …) are NOT gated and
 * must stay off this map.
 *
 * Today only the Shop module has a dedicated tenant-admin surface (Products).
 * Booking / Online-services management happens inside specialties, which is
 * not module-gated. Add entries here as module-specific pages appear.
 */
export const MODULE_BY_PATH: Record<string, string> = {
  '/products': ModuleKeys.Shop,
  '/shop-orders': ModuleKeys.Shop,
};

/** Resolve the module a path belongs to (longest-prefix match), if any. */
export function requiredModuleForPath(path: string): string | undefined {
  const match = Object.keys(MODULE_BY_PATH)
    .filter((p) => path === p || path.startsWith(`${p}/`))
    .sort((a, b) => b.length - a.length)[0];
  return match ? MODULE_BY_PATH[match] : undefined;
}
